// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2PCJ4","item":"PaymentsMobile_item__3oKPA","label":"PaymentsMobile_label__3CEZ4","amount":"PaymentsMobile_amount__3TFBx"};